// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Traducoes_TraduzirFaltantesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/traducoes/traduzir_faltantes/{idioma}.
 * `traduzidas` / `falhas` are upstream's own counters for the sweep.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Traducoes_TraduzirFaltantesResponseDados {
ok: boolean
traduzidas: number
falhas: number
}

export type Traducoes_TraduzirFaltantesResponse = ApiResponse<Traducoes_TraduzirFaltantesResponseDados>;

registerResponseContract('Traducoes_TraduzirFaltantesResponse', {
  ok:         { type: 'boolean', required: true },
  traduzidas: { type: 'number',  required: true },
  falhas:     { type: 'number',  required: true },
})
